import BaseModuleMixin from '../../../mixins/BaseModuleMixin';
import BaseGestaoMixin from '../../../mixins/BaseGestaoMixin';

export default {
    mixins: [
        BaseModuleMixin, 
        BaseGestaoMixin, 
    ], 
    props: {
        moduleId: {
            type: String,
            required: true
        }
    },
    data(){
        return {
            help: {
                
            },
        }
    },
    computed: {
        moduleInternalCode() {
            return this.moduleId;
        },
    },
    
}